var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse collapse-nav-only menu",attrs:{"id":"menu-container"}},[(_vm.menu.items)?_c('MenuItems',{attrs:{"items":_vm.menu.items,"top":true,"id":"menu-top"}}):_c('span',{staticClass:"fal fa-spinner fa-spin"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }